import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

const app = createApp(App)
app.config.errorHandler = (err, instance, info) => {
  // surface Vue errors with component context so production traces are
  // actually actionable (combined with sourcemaps).
  // eslint-disable-next-line no-console
  console.error('[vue:error]', info, instance?.$options?.__name || instance?.$.type?.name, err)
}
window.addEventListener('unhandledrejection', (ev) => {
  // eslint-disable-next-line no-console
  console.error('[unhandled:promise]', ev.reason)
})
app.use(router).mount('#app')
